// ---------------------------------------------------------------------------
// "A oração de hoje ainda não foi aberta?" e "a curiosidade da semana ainda
// não foi vista?". Fica tudo no localStorage deste celular — nada vai para o
// banco. Uma data (YYYY-MM-DD) marcada por dia; basta abrir a tela para marcar.
// ---------------------------------------------------------------------------

const CHAVE_ORACAO = 'seliga_oracao_vista';
const CHAVE_CURIOSIDADE = 'seliga_curiosidade_vista';

/** Data de hoje no horário de Brasília (nunca volta um dia por fuso). */
export function hojeSP(): string {
  try {
    return new Intl.DateTimeFormat('sv-SE', { timeZone: 'America/Sao_Paulo' }).format(new Date());
  } catch {
    return new Date().toISOString().slice(0, 10);
  }
}

function ler(chave: string): string {
  try {
    return localStorage.getItem(chave) ?? '';
  } catch {
    return '';
  }
}

function gravar(chave: string, valor: string): void {
  try {
    if (valor) localStorage.setItem(chave, valor);
    else localStorage.removeItem(chave);
  } catch {
    /* armazenamento indisponível */
  }
}

/** A oração de hoje já foi aberta neste celular? */
export function oracaoVistaHoje(): boolean {
  return ler(CHAVE_ORACAO) === hojeSP();
}

export function marcarOracaoVista(): void {
  gravar(CHAVE_ORACAO, hojeSP());
}

/** A "Nova" da oração deve aparecer? */
export function temOracaoNova(): boolean {
  return !oracaoVistaHoje();
}

/** A curiosidade desta semana já foi vista? Guardamos a semana (ex.: 2026-W43). */
export function curiosidadeVista(semana: string): boolean {
  if (!semana) return false;
  return ler(CHAVE_CURIOSIDADE) === semana;
}

export function marcarCuriosidadeVista(semana: string): void {
  if (semana) gravar(CHAVE_CURIOSIDADE, semana);
}

/** "terça, 20/10" no horário de Brasília. */
export function rotuloHoje(): string {
  const d = new Date();
  try {
    return new Intl.DateTimeFormat('pt-BR', {
      timeZone: 'America/Sao_Paulo',
      weekday: 'long',
      day: '2-digit',
      month: '2-digit',
    })
      .format(d)
      .replace(/\.$/, '');
  } catch {
    return new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit' }).format(d);
  }
}